import { ReactTyped } from "react-typed";

function Header({introCallback, aboutMeCallback, workHistoryCallBack, personalProjectsCallback, contactMeCallback} : {introCallback: VoidFunction,
                                                                                            aboutMeCallback:  VoidFunction,
                                                                                            workHistoryCallBack:  VoidFunction,
                                                                                            personalProjectsCallback:  VoidFunction,
                                                                                            contactMeCallback:  VoidFunction}) {
  return (
  <header className="sticky">
    <button className="logo dark-button"
            onClick={() => introCallback()}>
                  <ReactTyped strings={["AW"]} cursorChar="_"/>
    </button>
    <button className="button dark-button"
            onClick={() => aboutMeCallback()}>About Me</button>
    <button className="button dark-button"
            onClick={() => workHistoryCallBack()}>Work History</button>
    <button className="button dark-button"
            onClick={() => personalProjectsCallback()}>Personal Projects</button>
    <button className="button dark-button"
            onClick={() => contactMeCallback()}>Contact Me</button>
  </header>
  );
}

export default Header; 